module.exports = __webpack_public_path__ + "static/dew-fff1e00d2e2969333ce6f5dc4b6f1c91.mp4";